module Meevo.Components.Filters {

    export function meevoGenderFilter($translate): angular.IFilterService {
        const filter = (input: any) => {
            
            switch (input) {
                case Meevo.Model.GenderEnum.Other:
                    return $translate.instant("LABEL_OTHER");
                case Meevo.Model.GenderEnum.Female:
                    return $translate.instant("LABEL_FEMALE");
                case Meevo.Model.GenderEnum.Male:
                    return $translate.instant("LABEL_MALE");
                case Meevo.Model.GenderEnum.NotSpecified:
                    return $translate.instant("LABEL_NOT_SPECIFIED");
            }
            return "";
        };
        return filter;
    }

    meevoGenderFilter.$inject = ['$translate'];

    angular.module("meevo.components.filters")
        .filter("meevoGender", meevoGenderFilter);
}